import React from "react";
import AccordionItem from "./accordionItem";

import "./tree.scss";

const Tree = ({ selectedItems = [], checkList, itemWasChecked, maxDonuts }) => {
  const handleCheckboxChange = (item, checked) => {
    let newCheckedIds = [...selectedItems];

    if (checked) {
      newCheckedIds = newCheckedIds.filter(
        (stateItem) => !(stateItem.id === item.id && stateItem.type === item.type)
      );
    } else if (selectedItems.length < maxDonuts) {
      newCheckedIds.push({ id: item.id, type: item.type });
    }
    itemWasChecked(newCheckedIds);

    return newCheckedIds;
  };

  return (
    <div id="tree">
      <ul className="accordion-tree">
        {checkList.map((item) => (
          <AccordionItem
            key={item.id}
            item={item}
            handleCheckboxChange={handleCheckboxChange}
            selectedItems={selectedItems}
            disabled={selectedItems.length >= maxDonuts}
          />
        ))}
      </ul>
    </div>
  );
};

export default Tree;
